import { Collapsible } from '@highlight/ui'
import { twMerge } from 'tailwind-merge'

interface ActionReferenceTriggerProps extends React.ComponentProps<typeof Collapsible.Trigger> {
  isLast?: boolean
}

function ActionReferenceTrigger({ className, children, isLast, ...props }: ActionReferenceTriggerProps) {
  return (
    <Collapsible.Trigger
      showIcon={true}
      onClick={(e) => e.stopPropagation()}
      className={twMerge(
        'text-foreground-secondary group/trigger relative flex cursor-pointer items-center justify-start gap-2 overflow-visible pb-3 pr-2 pt-1 text-left text-sm font-normal',
        '[&_[data-slot=item-icon]]:corner-smooth [&_[data-slot=item-icon]]:border-black-5 [&_[data-slot=item-icon]]:bg-on-dark [&_[data-slot=item-icon]]:size-4 [&_[data-slot=item-icon]]:overflow-hidden [&_[data-slot=item-icon]]:rounded-md [&_[data-slot=item-icon]]:border',
        className,
      )}
      iconClassName="group-hover/trigger:rotate-45 group-hover/trigger:stroke-2 text-foreground-secondary"
      {...props}
    >
      {children}
      {!isLast && (
        <span className="bg-border absolute left-2 top-[calc(100%-6px)] h-2 w-px origin-bottom group-data-[panel-open]/trigger:h-0" />
      )}
    </Collapsible.Trigger>
  )
}

export { ActionReferenceTrigger }
